import classnames from 'classnames'
import { twMerge } from 'tailwind-merge'

export const cn = (...args: classnames.ArgumentArray) => twMerge(classnames(...args))
